import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './js/App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
//setTimeout(() => {
root.render(
  <App />
);
//}, 5000);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
